const appTimer = name => {
    let start = new Date();
    return {
        stop: function() {
            let end  = new Date();
            let time = end.getTime() - start.getTime();
            console.log('Timer:', name, 'finished in', time, 'ms.');
        }
    }
};

export default appTimer;


// WEBPACK FOOTER //
// ./src/app-timer.js